import { EntitlementType } from '@/@types/entitlement';
import { InsuranceActivationStatus, InsuranceType } from '@/@types/insurance';
import { useGetProductsStatus } from '@/apiHooks/productsStatus.hook';
import { useGetHasEntitlement } from './useGetHasEntitlement.hook';

export const useAdacStatus = () => {
  const isEntitled = useGetHasEntitlement(EntitlementType.ADAC_WP);
  const { productsStatus } = useGetProductsStatus();
  const insurance = productsStatus?.insurancePackage;
  const status = isEntitled && insurance?.insuranceAssignment === InsuranceType.ADAC ? insurance.status : null;

  return {
    isEntitled,
    status,
    needsActivation: isEntitled && status === InsuranceActivationStatus.NOT_ACTIVATED,
  };
};
